import { render, staticRenderFns } from "./VariantSifterExportSessionModal.vue?vue&type=template&id=9d633bba&scoped=true&"
import script from "./VariantSifterExportSessionModal.vue?vue&type=script&lang=js&"
export * from "./VariantSifterExportSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterExportSessionModal.vue?vue&type=style&index=0&id=9d633bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d633bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d633bba')) {
      api.createRecord('9d633bba', component.options)
    } else {
      api.reload('9d633bba', component.options)
    }
    module.hot.accept("./VariantSifterExportSessionModal.vue?vue&type=template&id=9d633bba&scoped=true&", function () {
      api.rerender('9d633bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterExportSessionModal.vue"
export default component.exports